
import { ChartData, ChartOptions } from 'chart.js';
import { PolarArea, mixins } from 'vue-chartjs';
import { Component, Vue, Prop } from 'vue-property-decorator';

const { reactiveProp } = mixins;

@Component({
  mixins: [reactiveProp],
  extends: PolarArea,
})
export default class SubscriptionChartPolarAreaComponent extends Vue<PolarArea> {
  @Prop()
  private options: ChartOptions;

  private chartData: ChartData;

  constructor() {
    super();
  }

  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
}
